import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Eyebrow } from 'shared/components/Eyebrow';
import { Heading } from 'shared/components/Heading';

export default function NotFound() {
  const { t } = useTranslation('notFound');

  return (
    <section className="flex flex-col items-center justify-center px-6 py-24 md:py-40 text-center">
      <Eyebrow className="text-sm opacity-80 mb-4 block">
        404
      </Eyebrow>
      <Heading variant="page" className="text-on-surface mb-6">
        {t('heading')}
      </Heading>
      <p className="font-sans text-body-lg text-on-surface-variant opacity-80 max-w-md mb-10">
        {t('description')}
      </p>
      <Link
        to="/"
        className="inline-flex items-center justify-center px-8 py-3 rounded-full bg-btn-primary text-btn-primary-text font-sans text-sm font-medium tracking-wide transition-transform hover:scale-[1.02] focus-visible:ring-2 focus-visible:ring-tertiary focus-visible:ring-offset-2 focus-visible:outline-none"
      >
        {t('backHome')}
      </Link>
    </section>
  );
}
